import { withStatusOrder } from './utils';

export const OPTPL01 = {
    header: {
        en: 'Chat Initiated',
        hi: 'चैट शुरू हो गई है',
        kn: 'ಚಾಟ್ ಪ್ರಾರಂಭಿಸಲಾಗಿದೆ',
        ta: 'அரட்டையைத் தொடங்கியது',
        te: 'చాట్ ప్రారంభించబడింది',
    },
    label: {
        en: 'Enquiry Creation Pending',
        hi: 'पूछताछ निर्माण लंबित',
        kn: 'ವಿಚಾರಣೆಯ ರಚನೆ ಬಾಕಿಯಿದೆ',
        ta: 'விசாரணை உருவாக்கம் நிலுவையில் உள்ளது',
        te: 'విచారణ సృష్టి పెండింగ్‌లో ఉంది',
    },
    order: 1,
    color: 'info',
    description: {
        en: 'The customer has received the WhatsApp flow. Awaiting flow submission',
        hi: 'ग्राहक को व्हाट्सएप फ्लो प्राप्त हुआ है। प्रवाह जमा होने की प्रतीक्षा है',
        kn: 'ಗ್ರಾಹಕನು ವಾಟ್ಸಾಪ್ ಫ್ಲೋವನ್ನು ಸ್ವೀಕರಿಸಿದ್ದಾನೆ. ಫ್ಲೋ ಸಲ್ಲಿಕೆಗೆ ಕಾಯುತ್ತಿದೆ',
        ta: 'வாடிக்கையாளர் வாட்ஸ்அப் அனுமதி பெற்றுள்ளார். அனுமதி சமர்ப்பிக்க காத்திருக்கிறது',
        te: 'కస్టమర్ WhatsApp ఫ్లోను స్వీకరించాడు. ఫ్లో సమర్పణ కోసం వేచి ఉంది',
    },
};

export const OPTPL02 = {
    header: {
        en: 'Enquiry Created',
        hi: 'पूछताछ बनाई गई है',
        kn: 'ವಿಚಾರಣೆ ರಚಿಸಲಾಗಿದೆ',
        ta: 'விசாரணை உருவாக்கப்பட்டது',
        te: 'విచారణ సృష్టించబడింది',
    },
    label: {
        en: 'Income Details Pending',
        hi: 'आय विवरण लंबित',
        kn: 'ಆದಾಯದ ವಿವರಗಳು ಬಾಕಿಯಿವೆ',
        ta: 'வருவாய் விவரங்கள் நிலுவையில் உள்ளன',
        te: 'ఆదాయం వివరాలు పెండింగ్‌లో ఉన్నాయి',
    },
    order: 2,
    color: 'info',
    description: {
        en: 'The customer has received the WhatsApp flow. Awaiting flow submission',
        hi: 'ग्राहक को व्हाट्सएप फ्लो प्राप्त हुआ है। प्रवाह जमा होने की प्रतीक्षा है',
        kn: 'ಗ್ರಾಹಕನು ವಾಟ್ಸಾಪ್ ಫ್ಲೋವನ್ನು ಸ್ವೀಕರಿಸಿದ್ದಾನೆ. ಫ್ಲೋ ಸಲ್ಲಿಕೆಗೆ ಕಾಯುತ್ತಿದೆ',
        ta: 'வாடிக்கையாளர் வாட்ஸ்அப் அனுமதி பெற்றுள்ளார். அனுமதி சமர்ப்பிக்க காத்திருக்கிறது',
        te: 'కస్టమర్ WhatsApp ఫ్లోను స్వీకరించాడు. ఫ్లో సమర్పణ కోసం వేచి ఉంది',
    },
};

export const OPTPL03 = {
    header: {
        en: 'Income Details',
        hi: 'आय विवरण',
        kn: 'ಆದಾಯದ ವಿವರಗಳು',
        ta: 'வருவாய் விவரங்கள்',
        te: 'ఆదాయం వివరాలు',
    },
    label: {
        en: 'Aadhar Verification Pending',
        hi: 'आधार सत्यापन लंबित',
        kn: 'ಆಧಾರ್ ಪರಿಶೀಲನೆ ಬಾಕಿಯಿದೆ',
        ta: 'ஆதார் சரிபார்ப்பு நிலுவையில் உள்ளது',
        te: 'ఆధార్ ధృవీకరణ పెండింగ్‌లో ఉంది',
    },
    order: 3,
    color: 'info',
    description: {
        en: 'The customer has submitted the WhatsApp flow. Awaiting Aadhaar verification',
        hi: 'ग्राहक ने व्हाट्सएप प्रवाह जमा किया है। आधार सत्यापन की प्रतीक्षा है',
        kn: 'ಗ್ರಾಹಕನು ವಾಟ್ಸಾಪ್ ಫ್ಲೋವನ್ನು ಸಲ್ಲಿಸಿದ್ದಾನೆ. ಆಧಾರ್ ಪರಿಶೀಲನೆಗಾಗಿ ಕಾಯುತ್ತಿದೆ',
        ta: 'வாடிக்கையாளர் வாட்ஸ்அப் அனுமதியை சமர்ப்பித்துள்ளார். ஆதார் சரிபார்ப்புக்காக காத்திருக்கிறது',
        te: 'కస్టమర్ WhatsApp ఫ్లోను సమర్పించాడు. ఆధార్ ధృవీకరణ కోసం వేచి ఉంది',
    },
};

export const OPTPL06 = {
    header: {
        en: 'Aadhaar Verified',
        hi: 'आधार सत्यापित',
        kn: 'ಆಧಾರ್ ಪರಿಶೀಲನೆ ಮಾಡಿ',
        ta: 'ஆதார் சரிபார்க்கப்பட்டது',
        te: 'ఆధార్ ధృవీకరించబడింది',
    },
    label: {
        en: 'PAN Verification Pending',
        hi: 'पैन सत्यापन लंबित',
        kn: 'ಪ್ಯಾನ್ ಪರಿಶೀಲನೆ ಬಾಕಿಯಿದೆ',
        ta: 'பான் சரிபார்ப்பு நிலுவையில் உள்ளது',
        te: 'PAN ధృవీకరణ పెండింగ్‌లో ఉంది',
    },
    order: 6,
    color: 'info',
    description: {
        en: 'The customer has verified their Aadhaar',
        hi: 'ग्राहक ने अपना आधार सत्यापित कर लिया है',
        kn: 'ಗ್ರಾಹಕನು ತನ್ನ ಆಧಾರ್ ಪರಿಶೀಲಿಸಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் தனது ஆதாரைச் சரிபார்த்தார்',
        te: 'కస్టమర్ తన ఆధార్‌ను ధృవీకరించాడు',
    },
};

export const OPTPL07 = {
    header: {
        en: 'PAN Verified',
        hi: 'पैन सत्यापित',
        kn: 'ಪ್ಯಾನ್ ಪರಿಶೀಲನೆ ಮಾಡಿ',
        ta: 'பான் சரிபார்க்கப்பட்டது',
        te: 'PAN ధృవీకరించబడింది',
    },
    label: {
        en: 'Application Submitted',
        hi: 'आवेदन प्रस्तुत किया गया',
        kn: 'ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் சமர்ப்பிக்கப்பட்டது',
        te: 'అప్లికేషన్ సమర్పించబడింది',
    },
    order: 7,
    color: 'info',
    description: {
        en: 'The customer has verified their PAN',
        hi: 'ग्राहक ने अपना पैन सत्यापित कर लिया है',
        kn: 'ಗ್ರಾಹಕನು ತನ್ನ ಪ್ಯಾನ್ ಪರಿಶೀಲಿಸಿದ್ದಾನೆ',
        ta: 'வாடிக்கையாளர் தனது பானைச் சரிபார்த்தார்',
        te: 'కస్టమర్ తన PAN‌ను ధృవీకరించాడు',
    },
};

export const OPTPL08 = {
    header: {
        en: 'Application Submitted',
        hi: 'आवेदन प्रस्तुत किया गया',
        kn: 'ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் சமர்ப்பிக்கப்பட்டது',
        te: 'అప్లికేషన్ సమర్పించబడింది',
    },
    label: {
        en: 'Awaiting Decision',
        hi: 'निर्णय का इंतजार है',
        kn: 'ನಿರ್ಧಾರದಿಗಾಗಿ ಕಾಯುತ್ತಿದೆ',
        ta: 'தீர்மானத்திற்கு காத்திருக்கிறது',
        te: 'నిర్ణయానికి వేచి ఉంది',
    },
    order: 8,
    color: 'success',
    description: {
        en: 'The customer has submitted their application',
        hi: 'ग्राहक ने अपना आवेदन प्रस्तुत किया है',
        kn: 'ಗ್ರಾಹಕನು ತನ್ನ ಅರ್ಜಿಯನ್ನು ಸಲ್ಲಿಸಿದನು',
        ta: 'வாடிக்கையாளர் தனது விண்ணப்பத்தை சமர்ப்பித்துள்ளார்',
        te: 'కస్టమర్ తన అప్లికేషన్‌ను సమర్పించాడు',
    },
};

export const OPTPL09 = {
    header: {
        en: 'Loan Rejected',
        hi: 'ऋण अस्वीकृत',
        kn: 'ಸಾಲ ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
        ta: 'கடன் நிராகரிக்கப்பட்டது',
        te: 'రుణం తిరస్కరించబడింది',
    },
    label: {
        en: 'Application Rejected',
        hi: 'आवेदन अस्वीकृत',
        kn: 'ಅರ್ಜಿಯನ್ನು ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் நிராகரிக்கப்பட்டது',
        te: 'అప్లికేషన్ తిరస్కరించబడింది',
    },
    order: 9,
    color: 'error',
    description: {
        en: 'The loan application has been rejected',
        hi: 'ऋण आवेदन अस्वीकृत कर दिया गया है',
        kn: 'ಸಾಲದ ಅರ್ಜಿಯನ್ನು ತಿರಸ್ಕರಿಸಲಾಗಿದೆ',
        ta: 'கடன் விண்ணப்பம் நிராகரிக்கப்பட்டது',
        te: 'రుణం అప్లికేషన్ తిరస్కరించబడింది',
    },
};

export const OPTPL10 = {
    header: {
        en: 'Application Approved',
        hi: 'आवेदन स्वीकृत',
        kn: 'ಅರ್ಜಿಯು ಅಂಗೀಕರಿಸಲಾಗಿದೆ',
        ta: 'விண்ணப்பம் ஒப்புதலிடப்பட்டது',
        te: 'అప్లికేషన్ ఆమోదించబడింది',
    },
    label: {
        en: 'Awaiting Confirmation',
        hi: 'पुष्टि का इंतजार है',
        kn: 'ದೃಢೀಕರಣಕ್ಕಾಗಿ ಕಾಯುತ್ತಿದೆ',
        ta: 'உறுதிப்படுத்தல் காத்திருக்கிறது',
        te: 'నిర్ధారణ కోసం వేచి ఉంది',
    },
    order: 10,
    color: 'success',
    description: {
        en: 'The loan application has been approved',
        hi: 'ऋण आवेदन को स्वीकृत किया गया है',
        kn: 'ಸಾಲದ ಅರ್ಜಿಯನ್ನು ಅಂಗೀಕರಿಸಲಾಗಿದೆ',
        ta: 'கடன் விண்ணப்பம் ஒப்புதலிடப்பட்டது',
        te: 'రుణం అప్లికేషన్ ఆమోదించబడింది',
    },
};

export const UPLActiveCases = withStatusOrder({
    OPTPL01,
    OPTPL02,
    OPTPL03,
    OPTPL06,
    OPTPL07,
});

export const UPLContinueJourneyCases = withStatusOrder({
    OPTPL02,
    OPTPL03,
    OPTPL06,
    OPTPL07,
});

export const UPLSanction = withStatusOrder({
    OPTPL08,
});

export const UPLRejected = withStatusOrder({
    OPTPL01,
    OPTPL02,
    OPTPL03,
    OPTPL06,
    OPTPL07,
    // OPTPL09,
});


export const UPLCancelled = withStatusOrder({
    OPTPL01,
    OPTPL02,
    OPTPL03,
    OPTPL06,
    OPTPL07,
    OPTPL08,
});


const OPTPL02_Unserviceable = {
    ...OPTPL02,
    header: {
        ...OPTPL02.header,
        en: 'Unserviceable',
    }
};

export const UPLUnserviceable = withStatusOrder({
    OPTPL02: OPTPL02_Unserviceable,
});


export const getUPLAll = (currentStatusCode) => {
    let UPLAll = {
        OPTPL01,
        OPTPL02,
        OPTPL03,
        OPTPL06,
        OPTPL07,
        OPTPL08,
    };

    if (currentStatusCode === 'OPTPL09') {
        UPLAll = {
            ...UPLAll,
            OPTPL09,
        }
    } else if (currentStatusCode === 'OPTPL10') {
        UPLAll = {
            ...UPLAll,
            OPTPL10,
        }
    } else {
        UPLAll = {
            ...UPLAll,
            OPTPLXX: {
                header: {
                    en: 'Awaiting Decision',
                    hi: 'फैसले का इंतजार',
                    kn: 'ತೀರ್ಮಾನಕ್ಕಾಗಿ ಕಾಯಲಾಗುತ್ತಿದೆ',
                    ta: 'முடிவிற்காக காத்திருக்கிறது',
                    te: 'నిర్ణయం కోసం వేచి ఉంది',
                },
                color: 'success',
            },
        }
    }

    return withStatusOrder(UPLAll);
};
